import React from 'react'

const Social = () => {
  return (
    <div>
      <div className="home__social">
        {/* <a href="https://instagram.com/" className="home__social-icon" target="_blank" rel='noreferrer'>
        <i class="uil uil-instagram"></i>
        </a> */}
        <a href="https://twitter.com/KevFlores96" className="home__social-icon" target="_blank" rel='noreferrer'>
        <i class="uil uil-twitter"></i>
        </a>
        <a href="https://www.linkedin.com/in/kevin-flores96/" className="home__social-icon" target="_blank" rel='noreferrer'>
        <i class="uil uil-linkedin"></i>
        </a>
        <a href="https://github.com/KevNic96" className="home__social-icon" target="_blank" rel='noreferrer'>
        <i class="uil uil-github"></i>
        </a>

      </div>
    </div>
  )
}

export default Social
